if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const MAPPED_INDEX_TO_URL = {
  0: 'all',
  1: 'bathroom',
  2: 'kitchen',
  3: 'replens',
  4: 'little-keeps',
  5: 'gifts',
};

const MAPPED_URL_TO_INDEX = {
  'all': 0,
  'bathroom': 1,
  'kitchen': 2,
  'replens': 3,
  'little-keeps': 4,
  'gifts': 5,
};

const FADE_TIMEOUT = 500;
const allCarousels = Array.from(document.querySelectorAll('.plp-category-carousel'));

/* Initialize swiper for each collection */
allCarousels.forEach((carousel) => {
  const swiper = new Swiper(carousel, {
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    }
  });

  const controls = Array.from(carousel.parentElement.parentElement.parentElement.querySelectorAll('.plp-category-carousel-controls-item'));

  controls.forEach((control, controlIndex) => {
    if (controlIndex === 0) {
      control.classList.add('plp-category-carousel-controls-item--active');
    }
    control.addEventListener('click', (event) => handleControlClick(event, swiper, controlIndex));
  })
});

handleControlClick = (event, swiperInstance, controlIndex) => {
  const target = event.target;
  const siblings = Array.from(target.parentElement.children);
  
  siblings.forEach((sibling) => sibling.classList.remove('plp-category-carousel-controls-item--active'));
  target.classList.add('plp-category-carousel-controls-item--active');

  swiperInstance.slideTo(controlIndex);
}

// Init
// 4 sections
// All | Bathroom | Kitchen | Replen | Gifts
// All & Bathroom have same content
// Kitchen: plp-category-kitchen
// Replen:  plp-category-replen
// Little Keeps: plp-category-little-keeps
// Gifts:  plp-category-gift

window.addEventListener("DOMContentLoaded", () => {
  const filters = Array.from(document.querySelectorAll('.plp-filters-filter'));
  filters.forEach((filter, index) => filter.addEventListener('click', (event) => handleFilterClick(event, index)));

  const url = new URL(window.location.href);

  if (url.search.length) {
    // Make url filter active
    const formatted = url.search.replace('?filter=', '');
    filters[MAPPED_URL_TO_INDEX[formatted]].classList.add('plp-filters-filter--active');
    handleFilterClick(null, MAPPED_URL_TO_INDEX[formatted]);
  } else {
    // Make first filter active
    filters[0].classList.add('plp-filters-filter--active');
    handleFilterClick(null, 0);
  }
});

handleFilterClick = (event, index) => {
  const url = new URL(window.location.href);

  url.searchParams.set('filter', MAPPED_INDEX_TO_URL[index]);
  window.history.replaceState(null, null, url);

  const replenAllElement = document.querySelector('.plp-category--all-replen');
  const giftAllElement = document.querySelector('.plp-category--all-gift');
  const littleKeepsAllElement = document.querySelector('.plp-category--all-little-keeps');
  
  const replenElements = [
    ...Array.from(document.querySelectorAll('.plp-category--replen')),
    document.querySelector('.control-module'),
    document.querySelector('.home-plans')
  ];

  const giftsElements = [
    ...Array.from(document.querySelectorAll('.plp-category--gifts'))
  ];

  const littleKeepsElements = [
    ...Array.from(document.querySelectorAll('.plp-category--little-keeps'))
  ];
  
  const kitchenElement = document.querySelector('.plp-category--kitchen');
  const bathroomElements = [
    ...Array.from(document.querySelectorAll('.plp-category--bathroom')),
    document.querySelector('.plp-story'),
    replenAllElement,
  ];

  const allFilterElements = [...bathroomElements, littleKeepsAllElement, giftAllElement];
  
  // We are using this just to hide all of them on filter click
  const allElements = [
    ...replenElements, 
    kitchenElement, 
    ...bathroomElements, 
    giftAllElement, 
    littleKeepsAllElement,
    ...littleKeepsElements, 
    ...giftsElements
  ];

  if (event) {
    const target = event.currentTarget;
    const siblings = Array.from(target.parentElement.children);
    siblings.forEach((sibling) => sibling.classList.remove('plp-filters-filter--active'));
    target.classList.add('plp-filters-filter--active');

    const filtersContainer = document.querySelector('.plp-filters-container');

    if (window.scrollY > filtersContainer.offsetTop) {
      setTimeout(() => {
        window.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth',
        })
      }, 1000);
    }
  }

  const controlModule = document.querySelector('.control-module');
  const homePlans = document.querySelector('.home-plans');

  allElements.forEach((element, index) => {
    if (element) {
      element.classList.add('plp--fade');      
      setTimeout(() => {
        if (index === 0) {
          if (homePlans) {
            homePlans.style.display = 'none';
          }
          if (controlModule) {
            controlModule.style.display = 'none';
          }
        }
        element.classList.add('plp--hidden');
      }, FADE_TIMEOUT);
    }
  });

  switch (index) {
    case 0: // All
    setTimeout(() => {
      allFilterElements.forEach((element) => {
        if (element) {
          element.classList.remove('plp--hidden');
          setTimeout(() => {
            element.classList.remove('plp--fade');
          }, 100);
        }
      });
    }, FADE_TIMEOUT);
      break;
    case 1: // Bathroom
    setTimeout(() => {
      bathroomElements.forEach((element) => {
        if (element) {
          element.classList.remove('plp--hidden');
          setTimeout(() => {
            element.classList.remove('plp--fade');
          }, 100);
        }
      });
    }, FADE_TIMEOUT);
      break;
    case 2: // Kitchen
      setTimeout(() => {
        kitchenElement.classList.remove('plp--hidden');
        setTimeout(() => {
          kitchenElement.classList.remove('plp--fade');
        }, 100);
      }, FADE_TIMEOUT);
      break;
    case 3: // Replen
      setTimeout(() => {
        replenElements.forEach((replenElement, index) => {
          if (replenElement) {
            if (index === 0) {
              if (homePlans) {
                homePlans.style.display = 'block';
              }
              if (controlModule) {
                controlModule.style.display = 'block';
              }
            }
            replenElement.classList.remove('plp--hidden');
            setTimeout(() => {
              if (index === 0) {
                if (homePlans) {
                  homePlans.style.opacity = '1';
                }
                if (controlModule) {
                  controlModule.style.opacity = '1';
                }
              }
              replenElement.classList.remove('plp--fade');
            }, 100);
          }
        })
      }, FADE_TIMEOUT);
      break;
    case 4: // Little keeps
      setTimeout(() => {
        littleKeepsElements.forEach((element) => {
          if (element) {
            element.classList.remove('plp--hidden');
            setTimeout(() => {
              element.classList.remove('plp--fade');
            }, 100);
          }
        })
      }, FADE_TIMEOUT);
      break;
    case 5: // Gifts
      setTimeout(() => {
        giftsElements.forEach((element) => {
          if (element) {
            element.classList.remove('plp--hidden');
            setTimeout(() => {
              element.classList.remove('plp--fade');
            }, 100);
          }
        })
      }, FADE_TIMEOUT);
      break;
  }
}
